import store from '@/ambiente/store'
import Vue from 'vue'
import Biblioteca from '../Repositorio/Biblioteca'

export default {
  c_logs_erros() {
    return 'logs_erros_enviar_admservicos';
  },

  async incluirLogExcecao(
    modulo_sistema_id, 
    operacao, 
    request, 
    response
  ) {
    if (!store || !state || !store.state.usuario_logado) {
      await RSessao.buscarDadosCarregarSessao(this.axios);
    }

    let funcionario_id = '';
    let nome_funcionario = '';

    if (store && state && store.state.usuario_logado) {
      let usuario = await JSON.parse(
        JSON.stringify(store.state.usuario_logado)
      );

      if (usuario) {
        funcionario_id = usuario.funcionario_id;
        nome_funcionario = usuario.nome;
      }
    }

    let log = {
      modulo_sistema_id: modulo_sistema_id,
      funcionario_id: funcionario_id,
      nome_funcionario: nome_funcionario,
      operacao: operacao,
      request: request,
      response: response,
      data_hora_erro: Biblioteca.fData(new Date()),
      detalhes: {
        dados_dispositivo: Biblioteca.buscarDadosDispositivo(),
        sistema_operacional: Biblioteca.buscarSistemaOperacionalDispositivo(),
        tipo_rede: Biblioteca.buscarTipoRedeDispositivo(),
        economia_de_dados: Biblioteca.buscarModoEconomiaDadosDispositivo(),
        geolocalizacao: navigator.geolocation,
        velocidade_download: Biblioteca.buscarVelocidadeDownloadDispositivo(),
        latencia: Biblioteca.buscarDadosLatenciaDispositivo()
      }
    }

    let logs = [];
    if (localStorage.getItem(this.c_logs_erros)) {
      logs = JSON.parse(localStorage.getItem(this.c_logs_erros));
    }

    if (logs.length > 30) {
      logs = [];
    }

    logs.push(log);
    localStorage.setItem(this.c_logs_erros, JSON.stringify(logs));
    
    if (logs.length >= 10) {
      this.enviarLogsADMServicos();
    }
  },

  async enviarLogsADMServicos(empresa_grupo_adm_servicos_id) {
    let logs = [];
    if (localStorage.getItem(this.c_logs_erros)) {
      logs = JSON.parse(localStorage.getItem(this.c_logs_erros));
    }

    if (!logs || (logs.length == 0)) {
      console.log('caiu aqui pois não tem nada!');
      return;
    }

    let parametros = {
      empresa_grupo_id: empresa_grupo_adm_servicos_id,
      logs: logs
    }

    await Vue.axios.post(
      "http://admservicos.ddns.net:9000/ADMServicos/LogsADMWebHTTP",
      JSON.stringify({parametros}),
      {crossDomain: true}
    )
    .then( resposta => {
      localStorage.removeItem(this.c_logs_erros);
    })
    .catch(async error => {        
      console.log(JSON.stringify(error));
    })
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RLogADMServicos.js